import axios from "@/app/axios";

const getPosts = (type: "posts"|"text"|"maquette"|"beat", slug: string = '', filters?: object) => {
  return axios.get(`api/${type}${slug ? '/' + slug : ''}`, { params: filters }).then((res) => {
      return res.data as IPostListResult;
  });
};

const getPost = (slug: string) => {
  return axios.get(`api/post/${slug}`).then((res) => {
      return res.data as { post: IPostDetails, related_posts: IPostItem[] };
  });
};

const getCategories = () => {
  return axios.get(`api/categories`).then((res) => {
      return res.data as ICategory[];
  });
};

const likePost = (postId: number, newState: boolean) => {
    return axios.post(`api/like`, { postId, newState });
};

const PostsService = {
    getPosts,
    likePost,
    getCategories,
    getPost
};

export default PostsService;
